import {
  ContractNewProductsStep5ErrorScreen,
  ContractNewProductsStep5PendingScreen,
  ContractNewProductsStep5SuccessScreen,
} from '@/Contract/ui/atoms'
import { useContractNewProducts } from '@/Contract/ui/context'
import { LogaltyResponseStatus } from '@/Logalty/domain'
import { LogaltyStatusChecker } from '@/Logalty/ui/organisms'

const renderState = (state: LogaltyResponseStatus): JSX.Element => {
  switch (state) {
    case LogaltyResponseStatus.Pending:
      return <ContractNewProductsStep5PendingScreen />
    case LogaltyResponseStatus.Success:
      return <ContractNewProductsStep5SuccessScreen />
    case LogaltyResponseStatus.Error:
      return <ContractNewProductsStep5ErrorScreen />
    default:
      return <ContractNewProductsStep5PendingScreen />
  }
}

export const ContractNewProductsStep5 = (): JSX.Element => {
  const { autoEnrollmentModel, logalty } = useContractNewProducts()
  const { getSignStatus, signStatus } = logalty

  return (
    <LogaltyStatusChecker
      logalty={logalty}
      currentModel={autoEnrollmentModel}
      getSignStatus={() => getSignStatus(autoEnrollmentModel?.processType || 2)}
    >
      {renderState(signStatus)}
    </LogaltyStatusChecker>
  )
}
